import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m8.999 15.002 2.118-4.943 1.059 1.06.706.706 1.059 1.059zm9.179-12.003 1.059 1.059-6.355 6.355-1.06-1.06zm2.824 2.823-6.355 6.356-1.06-1.06 6.356-6.355zm.706.707a1 1 0 0 0 0-1.412l-1.06-1.06-.705-.706-1.06-1.058a1 1 0 0 0-1.411 0l-7.061 7.06.005.005c-.088.088-.166.19-.217.307L8.08 14.609a.999.999 0 0 0 1.312 1.311l4.942-2.117c.118-.051.219-.13.308-.217l.004.004z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M18 11.678V20c0 .552-.449 1-1 1H5c-.551 0-1-.448-1-1V6c0-.551.449-1 1-1h8.264l1-1H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9.322z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }